export default __webpack_public_path__ + "static/media/geomap-card-blurred-decoration.0b590e46.png";